import axios from 'axios'
import { IhLogUrl, baseUrl, ihFaceDetectUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 根据关键字分页查询Rfid日志记录
export function getRfids(params) {
  const url = IhLogUrl + '/rfids'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据关键字分页查询Rfid日志记录', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除rfid日志
export function deleteRfidLog(params) {
  const url = IhLogUrl + '/rfids/deleteRfidLog'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '删除rfid日志', res)
    }
    return Promise.resolve(res.data)
  })
}

// 根据关键字分页查询数据流量日志记录
export function getMobileDatas(params) {
  const url = IhLogUrl + '/mobileDatas'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据关键字分页查询数据流量日志记录', res)
    }
    return Promise.resolve(res.data)
  })
}
// 查询获取数据流量appNameList
export function mobileDatasAppNames() {
  const url = IhLogUrl + '/mobileDatas/appNames'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '查询获取数据流量appNameList', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据LogMobileData日志主键删除日志
export function deleteMobileDataLog(params) {
  const url = IhLogUrl + '/mobileDatas/deleteMobileDataLog'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据LogMobileData日志主键删除日志', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据关键字查询统计结果
export function mobileDatasStatistics(params) {
  const url = IhLogUrl + '/mobileDatas/statistics'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据关键字查询统计结果', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据关键字分页查询电池电量日志
export function getBatterys(params) {
  const url = IhLogUrl + '/batterys'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据关键字分页查询电池电量日志', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除电量日志
export function deleteBatteryLog(params) {
  const url = IhLogUrl + '/batterys/deleteBatteryLog'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '删除电量日志', res)
    }
    return Promise.resolve(res.data)
  })
}
// 电量日志根据关键字查询统计结果
export function batterysStatistics(params) {
  const url = IhLogUrl + '/batterys/statistics'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '电量日志根据关键字查询统计结果', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据关键字分页查询电池电量日志
export function getCalls(params) {
  const url = IhLogUrl + '/calls'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(result => {
    if (result.status !== 200 || (!!result.data && result.data.state !== 0)) {
      errorCollection('工作日志', '根据关键字分页查询电池电量日志', result)
    }
    return Promise.resolve(result.data)
  })
}
// 查询获取电池电量appNameList
export function batterysAppNames() {
  const url = IhLogUrl + '/batterys/appNames'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '查询获取电池电量appNameList', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除电量日志
export function deleteCallLog(params) {
  const url = IhLogUrl + '/calls/deleteCallLog'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(result => {
    if (result.status !== 200 || (!!result.data && result.data.state !== 0)) {
      errorCollection('工作日志', '删除电量日志', result)
    }
    return Promise.resolve(result.data)
  })
}
// 根据关键字分页查询媒体上传信息日志
export function mediaUploadInfo(params) {
  const url = IhLogUrl + '/mediaUploadInfo'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据关键字分页查询媒体上传信息日志', res)
    }
    return Promise.resolve(res.data)
  })
}
// 查询用户记录下的appName列表
export function mediaUploadAppNames() {
  const url = IhLogUrl + '/mediaUploadInfo/appNames'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '查询用户记录下的appName列表', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据mediaUploadInfo日志主键删除日志
export function deleteMediaUploadInfoLog(params) {
  const url = IhLogUrl + '/mediaUploadInfo/deleteMediaUploadInfoLog'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据mediaUploadInfo日志主键删除日志', res)
    }
    return Promise.resolve(res.data)
  })
}
// 媒体上传根据关键字查询统计结果
export function mediaUploadInfoStatistics(params) {
  const url = IhLogUrl + '/mediaUploadInfo/statistics'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '媒体上传根据关键字查询统计结果', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据关键字分页查询安全帽模块日志记录
export function getModules(params) {
  const url = IhLogUrl + '/modules'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据关键字分页查询安全帽模块日志记录', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除module日志
export function deleteModuleLog(params) {
  const url = IhLogUrl + '/modules/deleteModuleLog'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '删除module日志', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据关键字分页查询后台操作记录
export function getOperations(params) {
  const url = IhLogUrl + '/operations'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据关键字分页查询后台操作记录', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除后台操作日志
export function deleteOperationLog(params) {
  const url = IhLogUrl + '/operations/deleteOperationLog'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '删除后台操作日志', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据关键字分页查询电子围栏日志，分页查询
export function getGeoFences(params) {
  const url = IhLogUrl + '/geoFences'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据关键字分页查询电子围栏日志', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除GeoFence日志
export function deleteGeoFenceLog(params) {
  const url = IhLogUrl + '/geoFences/deleteGeoFenceLog'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '删除GeoFence日志', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据关键字分页查询一键求助日志记录，分页查询
export function getEmergencyHelp(params) {
  const url = IhLogUrl + '/emergencyHelp'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据关键字分页查询一键求助日志记录', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除一键求助日志
export function deleteEmergencyHelpLog(params) {
  const url = IhLogUrl + '/emergencyHelp/deleteEmergencyHelpLog'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '删除一键求助日志', res)
    }
    return Promise.resolve(res.data)
  })
}
// 系统统计信息
export function getStatistics(params) {
  const url = IhLogUrl + '/statistics/' + params.ouId
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '系统统计信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 系统统计信息 轨迹统计查询接口
export function getStatisTrace(params) {
  const url = IhLogUrl + '/statistics/trace/' + params.ouId
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', ' 系统统计信息轨迹统计查询', res)
    }
    return Promise.resolve(res.data)
  })
}
// 该机构下所有子机构
export function ouMapIncludeChildren(params) {
  const url = baseUrl + '/ou/ouListIncludeChildren/' + params.id
  return axios({
    method: 'get',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '查询指定机构下所有子机构', res)
    }
    return Promise.resolve(res.data)
  })
}
// 该机构下所有用户
export function allFullNames(params) {
  const url = baseUrl + '/ou/' + params.id + '/allFullNames/map'
  return axios({
    method: 'get',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '查询指定机构下所有用户', res)
    }
    return Promise.resolve(res.data)
  })
}
// 安卓出勤、活跃度统计
export function attendStatistics(params) {
  const url = IhLogUrl + '/statistics/attend/' + params.ouId
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 安卓出勤、活跃度统计
export function attendTimeStatistics(params) {
  const url = IhLogUrl + '/statistics/attend/time/' + params.ouId
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 安卓出勤、活跃度统计
export function attendUserStatistics(params) {
  const url = IhLogUrl + '/statistics/attend/user/' + params.ouId
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 查询语音识别记录列表接口
export function voiceDetectPage(params) {
  const url = ihFaceDetectUrl + '/voiceDetect/log/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '语音识别记录查询', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除语音识别记录
export function voiceDetectDelete(params) {
  const url = ihFaceDetectUrl + '/voiceDetect/log/batch/delete'
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '删除语音识别记录', res)
    }
    return Promise.resolve(res.data)
  })
}
//查询人脸识别记录列表接口
export function faceDetectPage(params) {
  const url = ihFaceDetectUrl + '/faceDetect/log/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '人脸识别记录查询', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除人脸识别记录
export function faceDetectDelete(params) {
  const url = ihFaceDetectUrl + '/faceDetect/log/batch/delete'
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '删除人脸识别记录', res)
    }
    return Promise.resolve(res.data)
  })
}
//根据id查询人脸识别记录
export function faceDetectId(params) {
  const url = ihFaceDetectUrl + '/faceDetect/log/feature'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '根据id查询人脸识别记录', res)
    }
    return Promise.resolve(res.data)
  })
}

// 导出系统统计excel
export function exportStatistics(params) {
  const url = IhLogUrl + '/statistics/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
